"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _genericValidation = require("../utils/genericValidation");

var _ButtonModule = _interopRequireDefault(require("./Button.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Modules
// Styles
var Button = function Button(props) {
  var text = props.text,
      clickHandler = props.clickHandler,
      isDisabled = props.isDisabled,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'blue' : _props$variant,
      className = props.className,
      _props$extraStyles = props.extraStyles,
      extraStyles = _props$extraStyles === void 0 ? {} : _props$extraStyles,
      id = props.id,
      form = props.form,
      type = props.type;

  var handleClick = function handleClick(e) {
    if (typeof e.preventDefault === 'function') e.preventDefault();
    if (isDisabled) return; // @ts-ignore: clickHandler is only called if it exists

    if ((0, _genericValidation.isFunction)(clickHandler)) clickHandler();
  };

  return /*#__PURE__*/_react.default.createElement("button", {
    className: [_ButtonModule.default.btn, _ButtonModule.default[variant], className].join(' '),
    style: extraStyles,
    onClick: handleClick,
    disabled: isDisabled,
    id: id,
    form: form,
    type: type
  }, text);
};

var _default = Button;
exports.default = _default;